import React, { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './UserMenu.css';

const UserMenu: React.FC = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  if (!isAuthenticated || !user) {
    return (
      <div className="auth-buttons">
        <button onClick={() => navigate('/login')} className="login-btn">
          登录
        </button>
        <button onClick={() => navigate('/register')} className="register-btn">
          注册
        </button>
      </div>
    );
  }

  const handleLogout = () => {
    logout();
    navigate('/');
    setShowMenu(false);
  };

  return (
    <div className="user-menu">
      <button 
        className="user-avatar"
        onClick={() => setShowMenu(!showMenu)}
      >
        {user.avatar ? (
          <img src={user.avatar} alt={user.username} />
        ) : (
          <div className="avatar-placeholder">
            {user.username.charAt(0).toUpperCase()}
          </div>
        )}
      </button>
      
      {showMenu && (
        <div className="user-dropdown">
          <div className="user-info">
            <p className="username">{user.username}</p>
            {user.email && <p className="email">{user.email}</p>}
          </div>
          <hr />
          {/* <button onClick={() => navigate('/profile')}>
            个人资料
          </button>
          <button onClick={() => navigate('/my-products')}>
            我的产品
          </button> */}
          <hr />
          <button onClick={handleLogout} className="logout-btn">
            退出登录
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu; 